import { useEffect } from 'react';

export function useBeforeUnload({ preventUnload }: { preventUnload: boolean }): void {
    useEffect(() => {
        const handleBeforeUnload = (event: BeforeUnloadEvent): void => {
            if (preventUnload) {
                event.preventDefault();
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [preventUnload]);
}
